import { render, staticRenderFns } from "./spray.vue?vue&type=template&id=45a70970&scoped=true"
import script from "./spray.vue?vue&type=script&lang=js"
export * from "./spray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a70970",
  null
  
)

export default component.exports